import { render } from "./IntroContent.vue?vue&type=template&id=b6db9626"
import script from "./IntroContent.vue?vue&type=script&lang=js"
export * from "./IntroContent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__